// require("./lib/pym");
const Sidechain = require("@nprapps/sidechain");

require("./analytics");
const classify = require("./lib/classify");
const dayjs = require("dayjs");

const stageExp = new RegExp(window.SLUGS.stage.path);
const liveExp = new RegExp(window.SLUGS.live.path);

//TODAY'S DATE
const todaysDate = dayjs().startOf("day");

const deadlineTypes = [
  {
    key: "In-person deadline",
    selector: "in-person"
  },
  { key: "Mail registration deadline",
    selector: "mail"
  },
  {
    key: "Online registration deadline",
    selector: "online"
  }
]

function calculateDeadline(deadline) {
  if (!deadline) return "";

  const deadlineDate = dayjs(`${deadline}, 2026`);
  const diffDate = deadlineDate.diff(todaysDate, "day", true);

  if (diffDate < 0 || diffDate > 7) return "";
  if (diffDate === 0) return "Today";
  if (diffDate === 1) return "Tomorrow";

  return "In the next week";
}

function hasDeadlinePassed(deadline) {
  if (!deadline) return false;

  const deadlineDate = dayjs(`${deadline}, 2026`);

  return deadlineDate.isBefore(todaysDate);
}

function getDeadlineColorClass(text) {
  if (text === "Today" || text === "Tomorrow") {
    return "red";
  }

  if (text === "In the next week") {
    return "orange";
  }

  return "";
}

function updateDeadlineStatus(section, deadlineConfig, stateData) {
  const deadline = stateData[deadlineConfig.key];
  const text = calculateDeadline(deadline);

  if (!text) return false;

  const deadlineBox = section.querySelector(`[data-deadline="${deadlineConfig.selector}"]`);

  const status = deadlineBox?.querySelector(".deadline-status");

  if (!status) return false;

  status.firstElementChild.textContent = text;
  status.style.visibility = "visible";

  const colorClass = getDeadlineColorClass(text)

  if (colorClass) {
    status.classList.add(colorClass)
  }

  return true
}

function updatePassedDeadlines(section, stateData) {
  let count = 0;

  deadlineTypes.forEach(deadlineConfig => {
    const deadline = stateData[deadlineConfig.key];

    if (!hasDeadlinePassed(deadline)) return;

    const deadlineBox = section.querySelector(`[data-deadline="${deadlineConfig.selector}"]`);

    deadlineBox?.classList.add("strikethrough");
    count++;
  });

  if (count === 0) return;

  const countText = {
    1: "One deadline has",
    2: "Two deadlines have",
    3: "Three deadlines have",
  }[count];

  const intro = section.querySelector(".deadline-intro");

  function hasElectionPassed(stateData, electionType) {
    
    const typeKey = {
      primary: "Primary Election Date",
      general: "General Election Date"
    }

    return hasDeadlinePassed(stateData[typeKey[electionType]])
  }

  if (!hasElectionPassed(stateData,section.dataset.deadlineType)) {
    intro?.insertAdjacentHTML(
      "afterbegin",
      `${countText} passed${
        stateData["Same-day registration"]
          ? `, but ${stateData.State} has same-day registration.`
          : "."
      } `
    );
  }

  const sameDayBox = section.querySelector(`[data-deadline="same-day"]`);

  if (sameDayBox && hasElectionPassed(stateData, section.dataset.deadlineType)) {
    sameDayBox?.classList.add("strikethrough");
  }

    
}

function updateDeadlineSection(section, stateData) {
  const deadlineContainer = section.querySelector(".deadline-container");

  let hasUpcomingDeadline = false;

  deadlineTypes.forEach(deadlineConfig => {
    const wasUpdated = updateDeadlineStatus(
      section,
      deadlineConfig,
      stateData
    );

    if (wasUpdated) {
      hasUpcomingDeadline = true;
    }
  });

  if (hasUpcomingDeadline) {
    deadlineContainer?.classList.add("has-upcoming-deadlines");
  }

  updatePassedDeadlines(section, stateData);
}

const guides = {
  primary: window.STATEDATA,
  general: window.GENERALDATA
};

document.querySelectorAll(".deadline-section").forEach(section => {
  const type = section.dataset.deadlineType;
  const stateData = guides[type];

  if(!stateData) return;

  updateDeadlineSection(section, stateData)
})